import React from 'react';

const CrossLineLong = (props) => {
  return (
    <svg width="81" height="44" viewBox="0 0 81 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <line
        y1="-0.5"
        x2="90.2314"
        y2="-0.5"
        transform="matrix(0.88275 -0.469842 0.460746 0.887532 0.986328 43.8286)"
        stroke="#E8E6E1"
      />
    </svg>
  );
};

export default CrossLineLong;
